"use strict";

(function () {
  const STORAGE_KEY = "milano__wishlist-items";
  const wishlistDiv = document.querySelector(".wishlist-page-main");
  if (!wishlistDiv) return;

  const list = wishlistDiv.querySelector(".wishlist-list-items");
  const emptyState = wishlistDiv.querySelector(".wishlist-no-product-js");

  const handles = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

  if (!handles.length) {
    emptyState.classList.remove("hidden");
    return;
  }

  emptyState.classList.add("hidden");
  list.innerHTML = "";

  handles.forEach((handle) => {
    fetch(`/products/${handle}.js`)
      .then((res) => {
        if (!res.ok) throw new Error("Not found");
        return res.json();
      })
      .then((product) => {
        const item = document.createElement("div");
        item.className =
          "col-6 col-md-4 col-lg-3 product-load wishlist-list";

          // item.innerHTML = `
          //   <div class="product-item product__item-js style-as-default">
          //     <div class="product-item__wrapper product-grid color-default">
                
          //       <!-- PRODUCT IMAGE -->
          //       <div class="product-item__inner relative">
          //         <!-- REMOVE FROM WISHLIST -->
          //   <button
          //     class="wishlist-remove-btn"
          //     data-product-handle="${product.handle}"
          //     aria-label="Remove from wishlist"
          //   >
          //     ✕
          //   </button>
          //         <a
          //           href="/products/${product.handle}"
          //           class="product__media product-item__media--ratio rounded block"
          //           style="--aspect-ratio: 1/1;"
          //         >
          //           <img
          //             src="${product.images[0]}"
          //             alt="${product.title}"
          //             class="product-image first-image"
          //             loading="lazy"
          //           />
          //         </a>
          //       </div>

          //       <!-- PRODUCT INFO -->
          //       <div class="product-item__information mt-15">
          //         <a
          //           href="/products/${product.handle}"
          //           class="product-item__name heading-style block lh-normal wishlist_item_title"
          //         >
          //           ${product.title}
          //         </a>

          //         <div class="product-item__price flex justify-content-center mt-5">
          //           <span class="price">
          //             ${(product.price / 100).toFixed(2)}
          //           </span>
          //         </div>
          //       </div>

          //     </div>
          //   </div>
          // `;
const price = (product.price / 100).toFixed(2);
const compareAt =
  product.compare_at_price && product.compare_at_price > product.price
    ? (product.compare_at_price / 100).toFixed(2)
    : null;

item.innerHTML = `
  <div class="product-item product__item-js style-as-default">
    <div class="product-item__wrapper product-grid color-default">

      <!-- PRODUCT IMAGE -->
      <div class="product-item__inner relative">

        <!-- REMOVE FROM WISHLIST -->
        <button
          class="wishlist-remove-btn"
          data-product-handle="${product.handle}"
          aria-label="Remove from wishlist"
        >
          ✕
        </button>

        <a
          href="/products/${product.handle}"
          class="product__media product-item__media--ratio rounded block"
          style="--aspect-ratio: 1/1;"
        >
          <img
            src="${product.images[0]}"
            alt="${product.title}"
            class="product-image first-image"
            loading="lazy"
          />
        </a>
      </div>

      <!-- PRODUCT INFO -->
      <div class="product-item__information mt-15">

        ${
          product.vendor
            ? `<div class="product-item__vendor dark-grey">${product.vendor}</div>`
            : ``
        }

        <a
          href="/products/${product.handle}"
          class="product-item__name capitalize heading-style no-underline fs-custom block lh-normal "
        >
          ${product.title}
        </a>

        <div class="card-product-price  flex align-center flex-wrap gap-5 relative">
                  <span class="price heading_weight primary-color price-same-style price--special">
            ${price} NOK
          </span>

          ${
            compareAt
              ? `<span class="price-regular strike_through">
                  ${compareAt} NOK
                </span>`
              : ``
          }
        </div>
      </div>

    </div>
  </div>
`;


        list.appendChild(item);
      })
      .catch(() => {});
  });
})();
/* ================================
   WISHLIST BUTTON CLICK HANDLER
================================ */

(function () {
  const STORAGE_KEY = "milano__wishlist-items";

  function getWishlist() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("button-wishlist");
    if (!btn) return;

    e.preventDefault();

    // const handle = btn.dataset.productHandle;
    // if (!handle) return;

    const handle = btn.dataset.productHandle;

// ❌ Ignore numeric IDs completely
if (!handle || /^\d+$/.test(handle)) return;

    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter((h) => h !== handle);
      btn.classList.remove("is-active");
    } else {
if (!wishlist.includes(handle)) {
  wishlist.push(handle);
}
      btn.classList.add("is-active");
    }

    // saveWishlist(wishlist);
    saveWishlist(wishlist);
syncWishlistCount();

  });
})();
function syncWishlistCount() {
  const wishlist =
    JSON.parse(localStorage.getItem("milano__wishlist-items")) || [];

  const count = wishlist.length;

  // Change selector if your theme uses a different one
  const counter = document.querySelector(".wishlist-count, .header-wishlist-count");

  if (counter) {
    counter.textContent = count;
    counter.classList.toggle("hidden", count === 0);
  }
}
// document.addEventListener("DOMContentLoaded", syncWishlistCount);
document.addEventListener("DOMContentLoaded", function () {
  syncWishlistCount();
  syncWishlistButtons();
});


/* ================================
   REMOVE FROM WISHLIST (PAGE)
================================ */

document.addEventListener("click", function (e) {
  const removeBtn = e.target.closest(".wishlist-remove-btn");
  if (!removeBtn) return;

  e.preventDefault();

  const handle = removeBtn.dataset.productHandle;
  if (!handle) return;

  let wishlist =
    JSON.parse(localStorage.getItem("milano__wishlist-items")) || [];

  // Remove item
  wishlist = wishlist.filter((h) => h !== handle);

  // Save
  localStorage.setItem(
    "milano__wishlist-items",
    JSON.stringify(wishlist)
  );

  // Remove card from DOM
  const card = removeBtn.closest(".wishlist-list");
  if (card) card.remove();

  // Sync header count
  syncWishlistCount();

  // Show empty state if needed
  if (!wishlist.length) {
    const emptyState = document.querySelector(".wishlist-no-product-js");
    if (emptyState) emptyState.classList.remove("hidden");
  }
});

function syncWishlistButtons() {
  const wishlist =
    JSON.parse(localStorage.getItem("milano__wishlist-items")) || [];

  document.querySelectorAll("button-wishlist").forEach((btn) => {
    const handle = btn.dataset.productHandle;

    if (!handle || /^\d+$/.test(handle)) return;

    if (wishlist.includes(handle)) {
      btn.classList.add("is-active");
    } else {
      btn.classList.remove("is-active");
    }
  });
}




// "use strict";

// const wishlist_items = JSON.parse(
//   localStorage.getItem("milano__wishlist-items")
// );
// const wishlistDiv = document.querySelector(".wishlist-page-main");
// var WishlistPageShopify = (function () {
//   return {
//     initWishlistItems: function () {
//       if (window.location.search.indexOf("page=") == -1) {
//         this.init();
//       }
//     },

//     init: function () {
//       const _this = this;
//       if (wishlistDiv) {
//         const div_no_product = wishlistDiv.querySelector(
//           ".wishlist-no-product-js"
//         );
//         if (wishlist_items === null || wishlist_items.length === 0) {
//           _this.skeletonFunction(0);
//           div_no_product.classList.remove("hidden");
//         } else {
//           var query = "";
//           wishlist_items.forEach((e, key, wishlist_items) => {
//             if (!Object.is(wishlist_items.length - 1, key)) {
//               query += e + "%20OR%20id:";
//             } else {
//               query += e;
//             }
//           });
//           const section_id = document.querySelector(".wishlist-page-section")
//             .dataset.sectionId;
//           var productAjaxURL =
//             "?section_id=" +
//             section_id +
//             "&type=product&options[unavailable_products]=last&q=id:" +
//             query;

//           fetch(`${window.routes.search_url}${productAjaxURL}`)
//             .then((response) => response.text())
//             .then((responseText) => {
//               const html = parser.parseFromString(responseText, "text/html");
//               const row = document.createElement("div");
//               row.classList.add("wishlist-list-items");
//               const exist_row = wishlistDiv.querySelector(
//                 ".wishlist-list-items"
//               );
//               if (exist_row) {
//                 exist_row.remove();
//               }
//               const er = html.querySelector(
//                 ".wishlist-page-main .wishlist-list-items"
//               );
//               if (wishlist_items.length !== 0 && er) {
//                 wishlistDiv.innerHTML = html.querySelector(
//                   ".wishlist-page-main"
//                 ).innerHTML;
//                 _this.skeletonFunction(700);
//               } else {
//                 _this.skeletonFunction(0);
//                 div_no_product.classList.remove("hidden");
//               }
//               _this.mergeItems();
//             })
//             .catch((e) => {
//               console.error(e);
//             })
//             .finally((e) => {
//               initLazyloadItem();
//             });
//         }
//       }
//     },
//     mergeItems: function () {
//       const arr = [];
//       if (wishlistDiv) {
//         wishlistDiv
//           .querySelectorAll(".product-item__action button-wishlist")
//           .forEach((e) => {
//             arr.push(e?.dataset.productId);
//           });
//       }
//       localStorage.setItem("milano__wishlist-items", JSON.stringify(arr));
//     },
//     skeletonFunction: function (timer) {
//       window.setTimeout(function () {
//         if (this.document.querySelector("skeleton-page")) {
//           this.document.querySelector("skeleton-page").remove();
//         }
//         if (this.document.querySelector(".wishlist-page-section-inner")) {
//           this.document
//             .querySelector(".wishlist-page-section-inner")
//             .classList.remove("hidden");
//         }
//       }, timer);
//     },
//   };
// })();
// WishlistPageShopify.initWishlistItems();
